import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";
import ElementCardForPageComponent from "./ElementCardForPageComponent.js";
import { cyan } from "@mui/material/colors";

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

const config = require("../../../constants/constants.js")

const CreateUserPageComponent = ({
  createUserApiRequest,
  registerUserApiRequest,
  reduxDispatch,
  newUser,
  deleteUser,
  saveAttributeToCatDoc
}) => {

  const [validated, setValidated] = useState(false);
  const [attributesTable, setAttributesTable] = useState([]);
  const [attributesFromDb, setAttributesFromDb] = useState([]);
  const [images, setImages] = useState(false);
  const [isCreating, setIsCreating] = useState("");
  const [createProductResponseState, setCreateUserResponseState] = useState({
    message: "",
    error: "",
  });
  const [userChoosen, setUserChoosen] = useState("Choose user");

  const [newAttrKey, setNewAttrKey] = useState(false);
  const [newAttrValue, setNewAttrValue] = useState(false);

  const attrVal = useRef(null);
  const attrKey = useRef(null);
  const createNewAttrKey = useRef(null);
  const createNewAttrVal = useRef(null);

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [role, setRole] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [shippingAddressItem, setShippingAddressItem] = useState({});
  const [shippingNameSurname, setShippingNameSurname] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [shippingZip, setShippingZip] = useState("");
  const [shippingCity, setShippingCity] = useState("");
  const [shippingProvince, setShippingProvince] = useState("");
  const [shippingPhone, setShippingPhone] = useState("");
  
  const [fieldNameError, setFieldNameError] = useState(false);
  const [fieldLastnameError, setFieldLastnameError] = useState(false);
  const [fieldEmailError, setEmailFieldError] = useState(false);
  const [fieldPasswordError, setFieldPasswordError] = useState(false);
  const [fieldRePasswordError, setFieldRePasswordError] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget.elements;
    const formInputs = {
      name: form.name.value,
      lastName: form.lastName.value,
      email: form.email.value,
      //isAdmin: form.isAdmin.value,
      isAdmin: false,
    };

    createUserApiRequest(formInputs);

    setValidated(true);

    window.location.assign('/admin/users')
  };

  const uploadHandler = (images) => {
    setImages(images);
  };

  const newUserHandler = (e) => {
    if (e.keyCode && e.keyCode === 13 && e.target.value) {
      reduxDispatch(newUser(e.target.value));
      setTimeout(() => {
        let element = document.getElementById("cats");
        setUserChoosen(e.target.value);
        element.value = e.target.value;
        e.target.value = "";
      }, 200);
    }
  };

  const deleteUserHandler = () => {
    let element = document.getElementById("cats");
    reduxDispatch(deleteUser(element.value));
    setUserChoosen("Choose user");
  };

  const checkKeyDown = (e) => {
    if (e.code === "Enter") e.preventDefault();
  }

  function createUser(eventKey) {

    eventKey.preventDefault();
    eventKey.stopPropagation();

    setState('IT');
    setIsAdmin(false);

    console.log(`name dig =`, name);
    console.log(`lastName dig =`, lastName);
    console.log(`email dig =`, email);
    console.log(`phoneNumber dig =`, phoneNumber);
    console.log(`address dig =`, address);
    console.log(`country dig =`, country);
    console.log(`zipCode dig =`, zipCode);
    console.log(`city dig =`, city);
    console.log(`state dig =`, state);
    console.log(`password dig =`, password);
    console.log(`role  =`, role);
    console.log(`isAdmin dig =`, isAdmin);

    const formInputs = {
      name: name,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNumber,
      address: address,
      country: country,
      zipCode: zipCode,
      city: city,
      state: state,
      password: password,
      role: role,
      isAdmin: isAdmin,
      shippingAddress :
        {
          nameSurname: shippingNameSurname,
          phone: shippingPhone,
          address: shippingAddress,
          zip: shippingZip,
          city: shippingCity,
          province: shippingProvince,
          phone: shippingPhone,
          description: "",
          note: "",
        }
    };

    if (
      name &&
      lastName &&
      email &&
      password &&
      repassword &&
      (password === repassword)
    ) {
      createUserApiRequest(formInputs);
      window.location.assign('/admin/users')
    }
  }

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/users')
  }

  const handleSelectRole = (event) => {
    setRole(event.target.value);
  };

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/users">
              {config.BC_ADMIN_USERS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_USERS_CREATE}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >
            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Crea utente</b>&nbsp;
            </Typography>
          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 20
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6'
            }}
            elevation={6}
          >

          <Stack
            useFlexGap
            sx={{
              flexDirection: { xs: "column", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
              flexWrap: 'wrap'
            }}
          >

            <TextField id="id-name" label="Nome" variant="outlined" defaultValue={name} required
              sx={{
                width: "35ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              error={fieldNameError}
              onChange={(event) => {
                setName(event.target.value);
                if (isLength(event.target.value, { min: 3, max: 15 })) {
                  setFieldNameError(false);
                } else {
                  setFieldNameError(true);
                }
              }}
            />

            <TextField id="id-lastName" label="Cognome" variant="outlined" defaultValue={lastName} required
              sx={{
                width: "35ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              error={fieldLastnameError}
              onChange={(event) => {
                setLastName(event.target.value);
                if (isLength(event.target.value, { min: 3, max: 15 })) {
                  setFieldLastnameError(false);
                } else {
                  setFieldLastnameError(true);
                }
              }}
            />

            <TextField id="id-email" label="Email" variant="outlined" defaultValue={email} required
              sx={{
                width: "35ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              error={fieldEmailError}
              onChange={(event) => {
                setEmail(event.target.value);
                if (isEmail(event.target.value)) {
                  setEmailFieldError(false);
                } else {
                  setEmailFieldError(true);
                }
              }}
            />

            <TextField id="id-phoneNumber" label="Telefono" variant="outlined" defaultValue={phoneNumber} required
              sx={{
                width: "20ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              onChange={(event) => {
                setPhoneNumber(event.target.value);
              }}
            />

            <TextField id="id-address" label="Indirizzo" variant="outlined" defaultValue={address} required
              sx={{
                width: "35ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              onChange={(event) => {
                setAddress(event.target.value);
              }}
            />
            <TextField id="id-city" label="Città" variant="outlined" defaultValue={city} required
              sx={{
                width: "25ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              onChange={(event) => {
                setCity(event.target.value);
              }}
            />
            <TextField id="id-country" label="Provincia" variant="outlined" defaultValue={country} required
              sx={{
                width: "20ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              onChange={(event) => {
                setCountry(event.target.value);
              }}
            />
            <TextField id="id-zipCode" label="Cap" variant="outlined" defaultValue={zipCode} required
              sx={{
                width: "15ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              onChange={(event) => {
                setZipCode(event.target.value);
              }}
            />

            <TextField id="id-password" label="Password" variant="outlined" defaultValue={password} required type="password"
              sx={{
                width: "35ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              error={fieldPasswordError}
              onChange={(event) => {
                setPassword(event.target.value);
                if (isStrongPassword(event.target.value)) {
                  setFieldPasswordError(false);
                } else {
                  setFieldPasswordError(true);
                }
              }}
            />

            <TextField id="id-repassword" label="Ripeti password" variant="outlined" defaultValue={repassword} required type="password"
              sx={{
                width: "35ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
              error={fieldRePasswordError}
              onChange={(event) => {
                setRepassword(event.target.value);
                if (isStrongPassword(event.target.value)) {
                  setFieldRePasswordError(false);
                } else {
                  setFieldRePasswordError(true);
                }
              }}
            />

            <FormControl
              sx={{
                width: "25ch",
                p: { xs: 1, md: 1 },
                m: { xs: 1, md: 1 },
              }}
            >
              <InputLabel id="demo-simple-select-label">
                Ruolo
              </InputLabel >
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={role}
                label="Ruolo"
                onChange={handleSelectRole}
              >
                <MenuItem value="Utente">Utente</MenuItem>
                <MenuItem value="Cliente">Cliente</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Owner">Owner</MenuItem>
              </Select>
            </FormControl>


              <Box
                component="fieldset"
                sx={{
                  border: 1,
                  background: '	#d0e6f5ff',
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                }}
              >

                <legend>&nbsp;&nbsp;indirizzo spedizione&nbsp;&nbsp;</legend>

                <TextField id="id-name" label="Cognome e nome" variant="outlined" value={shippingNameSurname} defaultValue={shippingNameSurname}
                  sx={{
                    width: "30ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  error={fieldNameError}
                  onChange={(event) => {
                    setShippingNameSurname(event.target.value);
                    if (isLength(event.target.value, { min: 3, max: 15 })) {
                      setFieldNameError(false);
                    } else {
                      setFieldNameError(true);
                    }
                  }}
                />

                <TextField id="id-address" label="Indirizzo" variant="outlined" value={shippingAddress} defaultValue={shippingAddress}
                  sx={{
                    width: "30ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingAddress(event.target.value);
                  }}
                />

                <TextField id="id-zipCode" label="Cap" variant="outlined" value={shippingZip} defaultValue={shippingZip}
                  sx={{
                    width: "15ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingZip(event.target.value);
                  }}
                />

                <TextField id="id-city" label="Città" variant="outlined" value={shippingCity} defaultValue={shippingCity}
                  sx={{
                    width: "25ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingCity(event.target.value);
                  }}
                />

                <TextField id="id-country" label="Provincia" variant="outlined" value={shippingProvince} defaultValue={shippingProvince}
                  sx={{
                    width: "25ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingProvince(event.target.value);
                  }}
                />

                <TextField id="id-telephone" label="Telefono" variant="outlined" value={shippingPhone} defaultValue={shippingPhone}
                  sx={{
                    width: "25ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingPhone(event.target.value);
                  }}
                />

              </Box>

          </Stack>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: "row", md: "row" },
              alignItems: "center",
              justifyContent: "center"
            }}
          >

            <Button
              type="button"
              variant="contained"
              color="warning"
              onClick={(e) => { gotoIndietro(e); }}
              sx={{
                width: "12ch",
                p: 1,
                m: 1,
              }}
            >
              Indietro
            </Button>

            <Button
              variant="contained"
              type="submit"
              color="success"
              onClick={(e) => { createUser(e); }}
              sx={{
                width: "12ch",
                p: 1,
                m: 1,
              }}
            >
              Crea
            </Button>
            {createProductResponseState.error ?? ""}

          </Box>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 20
              }}
            />

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid>

    </Box>

  );
};

export default CreateUserPageComponent;
